import {certificateElementType} from "~/enums/certificateElementType";
import DynamicModeCertificateElement from "./dynamicCertificateElement";
import GridCertificateElement from "./gridCertificateElement";


export default class GridCellCertificateElement extends DynamicModeCertificateElement {
  type: certificateElementType = certificateElementType.GridCell;
  column_span: number;
  row_span: number;
  parent: GridCertificateElement
  parent_cell_client_id: string

  get newElementCoordinates(){
    return {};
  }

  get parentCell(){
    if (!this.parent_cell_client_id){
      return this
    }else{
      return (this.parent.certificate_elements[this.parent_cell_client_id] as GridCellCertificateElement)
    }
  }

  /**
   * The content width of this cell.
   * Note: This must be kept in sync with width in grid_cell_certificate_element.rb
   */
  get cellWidth(){
    if (this.column_span === 0 || this.row_span === 0){
      return 0
    }else{
    // When a cell covers multiple columns, in addition to the internal widths of each column, its total width
    // also includes the widths of the inter-cell margins and cell borders that it covers.
    // -1 to calculate the number of gaps from the number of columns
    const absorbedCellMargin = (this.column_span - 1) * (this.parent.horizontal_cell_margin + 2 * this.parent.outline_thickness);
    return this.parent.baseCellWidth * this.column_span + absorbedCellMargin;
    }
  }

  get canVerticallySplit(): boolean{
    return this.row_span > 1
  }

  get canHorizontallySplit(): boolean{
    return this.column_span > 1
  }

  get isFull(): boolean{
    return this.certificateElementsArray.length > 0
  }

  get isEmpty() : boolean{
    return !this.isFull
  }

  get columnIndex(): number{
    return Math.floor(this.cellIndex%this.parent.column_count)
  }

  get visibleColumnIndex(): number {
    let visibleColumnIndex = 0
    this.parent.visibleColumns.forEach((columnGroup, index) => {
      if (columnGroup[this.rowIndex] === this) {
        visibleColumnIndex = index
      }
    })
    return visibleColumnIndex
  }

  get hasBeenVerticallyMergedInto(): boolean {
    return this.row_span === 0
  }

  get isVerticallyMergedIntoOtherCells(): boolean{
    return this.row_span > 1
  }

  get isHorizontallyMergedIntoOtherCells(): boolean{
    return this.column_span > 1
  }

  get hasBeenHorizontallyMergedInto(): boolean {
    return this.column_span === 0
  }

  //Handles modifying cells that are merged into this grid cell or cells that that this cell is merged into
  beforeDestroy() : GridCellCertificateElement{
    const rowPosition =  this.rowIndex
    if (this.hasBeenVerticallyMergedInto) {
      let mergedRowIndex = rowPosition - 1;
      while (this.parent.row(mergedRowIndex)[this.columnIndex].hasBeenVerticallyMergedInto) {
        mergedRowIndex--;
      }
      this.parent.row(mergedRowIndex)[this.columnIndex].row_span -= 1;
    }
    if (this.isVerticallyMergedIntoOtherCells){
      let mergedRowIndex = rowPosition + 1;
      this.parent.row(mergedRowIndex)[this.columnIndex].row_span = this.row_span -1
    }
    if (this.hasBeenHorizontallyMergedInto) {
      let mergedColumnIndex = this.columnIndex - 1;
      while (this.parent.row(rowPosition)[mergedColumnIndex].hasBeenHorizontallyMergedInto) {
        mergedColumnIndex--;
      }
      this.parent.row(rowPosition)[mergedColumnIndex].column_span -= 1;
    }
    if (this.isHorizontallyMergedIntoOtherCells){
      let mergedColumnIndex = this.columnIndex + 1;
      this.parent.row(rowPosition)[mergedColumnIndex].column_span = this.column_span -1
    }
    return this
  }

  get visibleRowIndex(): number {
    let visibleRowIndex = 0
    this.parent.visibleRows.forEach((rowGroup, index) => {
      if (rowGroup[this.columnIndex] === this) {
        visibleRowIndex = index
      }
    })
    return visibleRowIndex
  }
  get rowIndex(): number{
    return Math.floor(this.cellIndex/this.parent.column_count)
  }

  get cellIndex(): number{
    return this.parent.certificateElementsArray.indexOf(this)
  }

  get insertElement(): DynamicModeCertificateElement{
    return (this.certificateElementsArray[0] as DynamicModeCertificateElement)
  }

  get leftBoundX(){
    const baseLeftBoundX =this.parent.leftBoundX + this.parent.horizontal_cell_margin + this.parent.padding_left
    // the internal widths of the columns that come before this one
    return baseLeftBoundX + (this.columnIndex * (this.parent.baseCellWidth + this.parent.horizontal_cell_margin))
  }

  get rightBoundX(){
    return this.leftBoundX + this.cellWidth
  }
  get columnWidth(){
    const length = this.parent.visibleColumns.length;

    const containerWidth = this.parent.width - 30;
    return containerWidth / length;
  }
}